// extracted by mini-css-extract-plugin
export default {"central":"loader_central__D+p+V","loader":"loader_loader__M-FUL","load5":"loader_load5__KTlAo"};